import { db } from "../firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

// Campi da escludere dal log
const CAMPI_ESCLUSI = new Set([
  "idEventiCalendar", "cartellaDrive", "updatedAt", "createdAt",
  "oreCollaboratori",
]);

// Label leggibili per i campi
const LABEL_CAMPI = {
  titolo: "Titolo",
  tipoEvento: "Tipo evento",
  tipologiaEvento: "Tipologia evento",
  dataInizio: "Data inizio",
  oraInizio: "Ora inizio",
  dataFine: "Data fine",
  oraFine: "Ora fine",
  durata: "Durata (ore)",
  durataGiorni: "Durata (giorni)",
  clienteId: "Cliente",
  descrizione: "Descrizione",
  oreAlgores: "Ore Algores",
  oreCollaboratori: "Ore Collaboratori",
  importoVendita: "Importo di vendita",
  tecnologie: "Tecnologia",
  piattaformaStudio: "Piattaforma studio",
  piattaformaDistribuzione: "Piattaforma distribuzione",
  tenant: "Tenant",
  chatAttiva: "Chat attiva",
  drAttiva: "D&R attiva",
  chiFiltraDR: "Chi filtra D&R",
  canaleDR: "Canale D&R",
  liberatoriaRelatori: "Liberatoria relatori",
  registrazioneVideo: "Registrazione video",
  listaDestinatari: "Lista destinatari",
  demAttiva: "DEM attiva",
  demInvito: "DEM - Invito",
  demReminder: "DEM - Reminder",
  demPromemoria: "DEM - Promemoria",
  surveyPostEvento: "Survey post-evento",
  dataSurvey: "Data survey",
  demSurvey: "DEM - Survey",
  direzioneId: "Direzione",
  preventivoRif: "Preventivo di riferimento",
  opportunitaCRM: "Opportunità SuiteCRM",
  stato: "Stato",
  motivoAnnullamento: "Motivo annullamento",
  nuovaData: "Nuova data",
  controlloScript: "Controllo script",
  data: "Data evento (requirements)",
  location: "Location (requirements)",
  budget: "Budget (requirements)",
  contattiReferenti: "Contatti referenti",
};

// Formatta valore per visualizzazione
function formattaValore(valore) {
  if (valore === null || valore === undefined || valore === "") return "—";
  if (typeof valore === "boolean") return valore ? "Sì" : "No";
  if (Array.isArray(valore)) return valore.length > 0 ? valore.join(", ") : "—";
  return String(valore);
}

// Calcola diff tra due oggetti annidati (aree, giornate)
function diffOggettoAnnidato(vecchio, nuovo, prefisso) {
  const modifiche = [];
  const tutteLeChiavi = new Set([
    ...Object.keys(vecchio || {}),
    ...Object.keys(nuovo || {}),
  ]);

  for (const chiave of tutteLeChiavi) {
    const v = vecchio?.[chiave];
    const n = nuovo?.[chiave];

    if (typeof v === "object" && !Array.isArray(v) && v !== null) {
      // Oggetto annidato (es. aree.audio)
      const sottoModifiche = diffOggettoAnnidato(v, n, `${prefisso}.${chiave}`);
      modifiche.push(...sottoModifiche);
    } else {
      const vStr = formattaValore(v);
      const nStr = formattaValore(n);
      if (vStr !== nStr) {
        modifiche.push({
          campo: `${prefisso}.${chiave}`,
          da: vStr,
          a: nStr,
        });
      }
    }
  }

  return modifiche;
}

// Calcola tutte le modifiche tra evento vecchio e nuovo
export function calcolaModifiche(vecchio, nuovo, clientiMap = {}) {
  if (!vecchio) return [{ campo: "Evento", da: "—", a: "Creato" }];

  const modifiche = [];

  for (const chiave of Object.keys(nuovo)) {
    if (CAMPI_ESCLUSI.has(chiave)) continue;

    const v = vecchio[chiave];
    const n = nuovo[chiave];

    // Oggetti annidati (aree, giornate)
    if (typeof n === "object" && !Array.isArray(n) && n !== null) {
      const sottoModifiche = diffOggettoAnnidato(v, n, LABEL_CAMPI[chiave] || chiave);
      modifiche.push(...sottoModifiche);
      continue;
    }

    const vStr = formattaValore(v);
    const nStr = formattaValore(n);

    if (vStr !== nStr) {
      let label = LABEL_CAMPI[chiave] || chiave;
      let daLabel = vStr;
      let aLabel = nStr;

      // Risolvi clienteId in nome cliente
      if (chiave === "clienteId") {
        daLabel = clientiMap[v] || v || "—";
        aLabel = clientiMap[n] || n || "—";
      }

      modifiche.push({ campo: label, da: daLabel, a: aLabel });
    }
  }

  return modifiche;
}

// Salva un log in Firestore
export async function salvaLog(utente, tipoOperazione, eventoId, titoloEvento, modifiche = []) {
  try {
    await addDoc(collection(db, "log"), {
      operatore: {
        uid: utente?.uid || "",
        nome: utente?.displayName || "",
        email: utente?.email || "",
      },
      tipoOperazione,
      eventoId: eventoId || "",
      titoloEvento: titoloEvento || "",
      modifiche,
      timestamp: serverTimestamp(),
    });
  } catch (error) {
    console.error("Errore salvataggio log:", error);
  }
}